import { RefObject } from 'react';
import { EntityFormReducerState } from '../reducer/interfaces';
import { ButtonProps } from '../../button/Button';
import { EntityFormImperativeRef } from '../EntityForm';

export function TestConnectionPropsFactory(
  state: EntityFormReducerState & { isValidating: boolean },
  formRef: RefObject<EntityFormImperativeRef>,
  submitText: string = 'Test & Continue'
): Partial<ButtonProps> {
  const { savingForm, testConnectionRunning, isValidating } = state;

  const disableContinueCTA = savingForm || testConnectionRunning || isValidating;

  let title = submitText;

  if (savingForm) {
    title = 'Saving Form';
  } else if (testConnectionRunning) {
    title = 'Testing';
  }

  return {
    onClick: () => formRef.current?.submitForm(),
    showProgress: disableContinueCTA,
    disabled: disableContinueCTA,
    children: title
  };
}
